const ssn = {
    ssn : {
        value: "",
        dbqName: "topmostSubform[0].Page_1[0].SocialSecurityNo\\.[0]"
     },
     docName: {
         value: "",
         dbqName: "topmostSubform[0].Page_5[0].TextField8[1]"
     },
     docArea: {
        value: "",
        dbqName: "topmostSubform[0].Page_5[0].TextField8[6]"
    },
     docDate: {
        value : "",
        dbqName: "topmostSubform[0].Page_5[0].TextField8[7]"
    },
     docNpi: {
         value : "",
         dbqName: "topmostSubform[0].Page_5[0].TextField8[3]"
     },
     docLicenseNo: {
        value : "",
        dbqName: "topmostSubform[0].Page_5[0].TextField8[4]"
    },
     docPhone: {
        value : "",
        dbqName: "topmostSubform[0].Page_5[0].TextField8[2]"
    },
    docAddress: {
        value : "",
        dbqName: "topmostSubform[0].Page_5[0].TextField8[5]"
    },
    diagnosisDate : [
        {
            type: "checkbox",
            dbqName: "topmostSubform[0].Page_2[0].CB1b1[0]",
            dateDbqName: "topmostSubform[0].Page_2[0].DateOfDiagnosis[0]",
        },
        {
            type: "checkbox",
            dbqName: "topmostSubform[0].Page_2[0].CB1b2[0]",
            dateDbqName: "topmostSubform[0].Page_2[0].DateOfDiagnosis[7]",
        },
        {
            type: "checkbox",
            dbqName: "topmostSubform[0].Page_2[0].CB1b3[0]",
            dateDbqName: "topmostSubform[0].Page_2[0].DateOfDiagnosis[1]",
        },
        {
            type: "checkbox",
            dbqName: "topmostSubform[0].Page_2[0].CB1b4[0]",
            dateDbqName: "topmostSubform[0].Page_2[0].DateOfDiagnosis[6]",
        },
        {
            type: "checkbox",
            dbqName: "topmostSubform[0].Page_2[0].CB1b5[0]",
            dateDbqName: "topmostSubform[0].Page_2[0].DateOfDiagnosis[2]",
        },
        {
            type: "checkbox",
            dbqName: "topmostSubform[0].Page_2[0].CB1b6[0]",
            dateDbqName: "topmostSubform[0].Page_2[0].DateOfDiagnosis[5]",
        },     
        {
            type: "text",
            dbqName: "topmostSubform[0].Page_2[0].Diagnosis1[0]",
            dateDbqName: "topmostSubform[0].Page_2[0].DateOfDiagnosis[3]",
        },
        {
            type: "text",
            dbqName: "topmostSubform[0].Page_2[0].Diagnosis2[0]",
            dateDbqName: "topmostSubform[0].Page_2[0].DateOfDiagnosis[4]",
        },        
    ]

}

export default ssn ;